export type IntegrationStatus = "available" | "beta" | "soon"

export type AtlasIntegration = {
  slug: string
  status: IntegrationStatus
}

export type Integration = {
  slug: string
  name: string
  category: string
  detail: string
  logo: string
}

export const integrationStatusLabels: Record<IntegrationStatus, string> = {
  available: "Доступно",
  beta: "Beta",
  soon: "Скоро",
}

export const atlasIntegrations: readonly AtlasIntegration[] = [
  { slug: "n8n", status: "available" },
  { slug: "metabase", status: "available" },
  { slug: "mattermost", status: "available" },
  { slug: "penpot", status: "available" },
  { slug: "docuseal", status: "available" },
  { slug: "stirling-pdf", status: "available" },
  { slug: "docmost", status: "available" },
  { slug: "nextcloud", status: "available" },
  { slug: "openclaw", status: "available" },
] as const

export const integrationFlowSources: readonly Integration[] = [
  {
    slug: "amocrm",
    name: "amoCRM",
    category: "CRM",
    detail: "лиды, сделки, контакты, статусы",
    logo: "/integrations/amocrm.svg",
  },
  {
    slug: "notion",
    name: "Notion",
    category: "База знаний",
    detail: "страницы, базы данных, регламенты",
    logo: "/integrations/notion.svg",
  },
  {
    slug: "google-drive",
    name: "Google Drive",
    category: "Файлы",
    detail: "общие диски, документы, таблицы",
    logo: "/integrations/google-drive.svg",
  },
] as const

export const popularIntegrations: readonly Integration[] = [
  {
    slug: "amocrm",
    name: "amoCRM",
    category: "CRM",
    detail: "сделки, контакты, задачи и заметки менеджеров",
    logo: "/integrations/amocrm.svg",
  },
  {
    slug: "bitrix24",
    name: "Битрикс24",
    category: "CRM и портал",
    detail: "воронки, задачи, чаты, телефония и компании",
    logo: "/integrations/bitrix.svg",
  },
  {
    slug: "notion",
    name: "Notion",
    category: "База знаний",
    detail: "страницы, базы данных, регламенты и проектные заметки",
    logo: "/integrations/notion.svg",
  },
  {
    slug: "yandex-disk",
    name: "Яндекс Диск",
    category: "Файлы",
    detail: "документы, папки, ссылки и вложения по клиентам",
    logo: "/integrations/yandex-disk.svg",
  },
  {
    slug: "google-drive",
    name: "Google Drive",
    category: "Файлы",
    detail: "общие диски, документы, таблицы и презентации",
    logo: "/integrations/google-drive.svg",
  },
  {
    slug: "telegram",
    name: "Telegram",
    category: "Коммуникации",
    detail: "заявки, уведомления, согласования и боты",
    logo: "/integrations/telegram.svg",
  },
] as const
